<template>
    <v-list v-if="groupedTime" class="list-tracking px-0 postion-relative" nav density="compact">
        <h6 class="mb-2">Geregistreerde tijd</h6>
        <v-list-group v-for="(userEntries, userId) in groupedTime" :key="userId" collapse-icon="fal" append-icon="fal"
            expand-icon="fal">
            <template v-slot:activator="{ props }">
                <div class="pa-2 d-flex my-auto" v-bind="props">
                    <assignees :users="users" :selected="userEntries.user.id" :value="userEntries.user.id" show_names />
                    <v-spacer></v-spacer>
                    <p class="my-auto pr-2">
                        {{ formatDuration(userEntries.totalTime) }}
                    </p>
                </div>
            </template>

            <v-list-item v-for="(entry, index) in userEntries.entries" :key="index" class="k-card-border pl-0"
                @click="openMenu(entry)">

                <v-list-item-title class="pl-0">
                    <span v-if="entry.start_time === entry.end_time">
                        {{ formatDate(entry.start_time) }} {{ formatTime(entry.start_time) }}
                    </span>
                    <span v-else>
                        {{ formatDate(entry.start_time) }} {{ formatTime(entry.start_time) }} -
                        {{ formatTime(entry.end_time) }} {{ formatDate(entry.end_time) }}
                    </span>
                    <span v-if="entry.source"> ({{ entry.source }}) </span>
                </v-list-item-title>
                <v-list-item-subtitle v-if="entry.description">
                    {{ entry.description }}
                </v-list-item-subtitle>

                <template v-slot:append>
                    <p class="mr-2">{{ formatDuration(entry.time) }}</p>
                    <v-btn color="danger" density="compact" size="small" icon variant="text"
                        @click.stop="removeTime(entry)">
                        <v-icon>fal fa-trash-alt</v-icon>
                    </v-btn>
                </template>
            </v-list-item>
            <v-menu v-model="menuOpen" location="bottom" class="timetracking-menu" :close-on-content-click="false"
                transition="slide-y-transition" absolute :position-x="menuX" :position-y="menuY" width="500"
                max-height="700">
                <TimeTrackingForm :timeSpent="timeSpent" :users="users" :current_user_id="current_user_id"
                    :fielddata="selectedItem" @update-time="handleUpdateTime" />
            </v-menu>
        </v-list-group>
    </v-list>

</template>
<script>
import TimeTrackingForm from "@/components/dashboards/datafields/timetrackingform.vue";


export default {
    name: "TimeTrackingMenu",
    props: {
        timeSpent: { type: Array, required: true },
        users: { type: Array, required: true }
    },
    components: {
        TimeTrackingForm
    },
    data() {
        return {
            groupedTime: {},
            menuOpen: false,
            menuX: 0,
            menuY: 0,
            selectedItem: null,
        };
    },
    computed: {
        groupedTime() {
            const result = {};
            this.timeSpent.forEach(entry => {
                const userId = entry.user_id;
                if (!result[userId]) {
                    result[userId] = {
                        user: this.users.find(user => user.id === userId),
                        entries: [],
                        totalTime: 0
                    };
                }
                result[userId].entries.push(entry);
                result[userId].totalTime += entry.time;
            });
            return result;
        }
    },
    methods: {
        formatDuration(minutes) {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = minutes % 60;
            if (hours > 0 && remainingMinutes > 0) return `${hours} u ${remainingMinutes} m`;
            if (hours > 0) return `${hours} u`;
            return `${remainingMinutes} m`;
        },

        formatDate(date) {
            const d = new Date(date);
            return d.toLocaleDateString('nl-NL', { year: 'numeric', month: '2-digit', day: '2-digit' });
        },

        formatTime(time) {
            const d = new Date(time);
            return `${d.getUTCHours().toString().padStart(2, '0')}:${d.getUTCMinutes().toString().padStart(2, '0')}`;
        },

        removeTime(entry) {
            // Zoek de gebruiker en verwijder de entry
            const userEntries = this.groupedTime[entry.user_id].entries;
            const index = userEntries.findIndex(e => e.id === entry.id);

            if (index !== -1) {
                userEntries.splice(index, 1);  // Verwijder de entry uit de array

                // Werk de totale tijd bij
                this.groupedTime[entry.user_id].totalTime -= entry.time;

                // Emit de verwijderde entry naar de parent component om de data bij te werken
                this.$emit('update:remove-timespend', entry);

                // Als er geen entries meer zijn voor de gebruiker, verwijder de gebruiker
                if (userEntries.length === 0) {
                    delete this.groupedTime[entry.user_id];
                }
            }
        },


        openMenu(entry) {

            this.selectedItem = entry;
            console.log(this.selectedItem);
            this.menuOpen = true;
        },

        handleUpdateTime(updatedEntry) {
            const userEntries = this.groupedTime[updatedEntry.user_id].entries;
            const index = userEntries.findIndex(e => e.id === updatedEntry.id);
            if (index > -1) userEntries[index] = updatedEntry;
            this.menuOpen = false;
        }
    }
};
</script>


<style>
.list-tracking {

    .v-list-group {
        .v-list-group__items {
            height: 200px;
            overflow: auto;
        }
    }

    .v-list-group__items .v-list-item {
        padding-left: 10px !important;
    }

    .assignee-container .v-list-item__overlay {
        display: none;
    }

    .v-list-group {
        border: 1px solid rgba(214, 217, 222, 0.6) !important;
        box-shadow: 0 1px 4px #0000000a !important;
        width: 100%;
        overflow: scroll !important;
        border-radius: 12px;
        margin-bottom: 4px;

        &:hover {
            cursor: pointer;

        }

        .v-list-group__items {
            padding: 4px;


            .v-list-item-title {
                font-size: 14px;
                font-weight: 500;
                margin-bottom: 4px;
            }

            .v-list-item-subtitle {
                font-size: 14px;
                color: #6c757d;
            }

        }
    }
}
</style>